import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {blendColors} from '../../../libs/shared/ui/src/styles/colorHelpers';
import {SettingsTopbarSearchContainer} from './search/settingsTopbarSearchContainer';

/*
 * Props.
 */

interface SettingsTopbarProps {
  settingsPath: string;
  className?: string;
  hasOverlay: boolean;
}

/*
 * Style.
 */

const StyledTopbarDiv = styled.div<{$hasOverlay: boolean}>`
  height: 61px;
  width: 100%;
  background: ${(p) => p.theme.greys.shade10};
  border-bottom: 1px solid ${(p) => p.theme.alphas.black20};
  position: relative;

  padding: 10px 22px 10px 20px;

  display: flex;
  align-items: flex-start;

  &::before {
    content: '';
    position: absolute;
    background: rgba(33, 33, 33, 0.85);
    width: 100%;
    height: 100%;
    z-index: 9;
    top: 0;
    left: 0;
    opacity: 0;
    pointer-events: none;
  }

  ${(p) => addOverlayStyles(p.$hasOverlay)}
`;

function addOverlayStyles(hasOverlay: boolean) {
  if (hasOverlay) {
    return css`
      border-bottom-color: ${(p) => blendColors(p.theme.alphas.black20, 'rgba(33,33,33,0.85)')};
      pointer-events: none;

      &::before {
        opacity: 1;
      }
    `;
  }

  return '';
}

const StyledSpacer = styled.div`
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 20px;
`;

const StyledInputWrapperDiv = styled.div`
  flex-basis: 100%;
  max-width: 530px;
  min-width: 300px;
`;

/*
 * Component.
 */

export const SettingsTopbar: FC<SettingsTopbarProps> = (props) => (
  <StyledTopbarDiv className={props.className} $hasOverlay={props.hasOverlay}>
    <StyledInputWrapperDiv>
      <SettingsTopbarSearchContainer settingsPath={props.settingsPath} />
    </StyledInputWrapperDiv>
    <StyledSpacer />
  </StyledTopbarDiv>
);
